import { RenderList } from "../components/render-list";

import type React from "react";

export interface FaqItem {
  question: string | [string, Record<string, string>];
  answer?: string;
  children?: React.ReactNode;
}

export const getCardV2faqData = (
  variables: Record<string, string> = {}
): FaqItem[] => [
  {
    question: "card_faq_google_wallet_question",
    children: (
      <RenderList
        items={[
          "card_faq_google_wallet_step1",
          "card_faq_google_wallet_step2",
          "card_faq_google_wallet_step3",
          "card_faq_google_wallet_step4",
          "card_faq_google_wallet_step5",
          "card_faq_google_wallet_step6",
        ]}
      />
    ),
  },
  {
    question: "card_faq_apple_wallet_question",
    children: (
      <RenderList
        items={[
          "card_faq_apple_wallet_step1",
          "card_faq_apple_wallet_step2",
          "card_faq_apple_wallet_step3",
          "card_faq_apple_wallet_step4",
          "card_faq_apple_wallet_step5",
          "card_faq_apple_wallet_step6",
        ]}
      />
    ),
  },
  {
    question: [
      "card_faq_online_payments_question",
      { client: variables.cardClient },
    ],
    children: (
      <RenderList
        items={[
          "card_faq_online_payments_step1",
          "card_faq_online_payments_step2",
          "card_faq_online_payments_step3",
        ]}
      />
    ),
  },
  {
    question: [
      "card_faq_instore_payments_question",
      { client: variables.cardClient },
    ],
    children: (
      <RenderList
        items={[
          "card_faq_instore_payments_step1",
          "card_faq_instore_payments_step2",
          "card_faq_instore_payments_step3",
        ]}
      />
    ),
  },
  {
    question: "card_faq_tracking_transactions_question",
    children: (
      <RenderList
        items={[
          {
            key: "card_faq_tracking_transactions_step1",
            variables,
          },
          "card_faq_tracking_transactions_step2",
        ]}
      />
    ),
  },
];
